import script from "./BooksPick.vue?vue&type=script&setup=true&lang=ts"
export * from "./BooksPick.vue?vue&type=script&setup=true&lang=ts"

import "./BooksPick.vue?vue&type=style&index=0&id=6121ce1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6121ce1c"]])

export default __exports__